// client\src\requireAuth.js
import React from "react";
import { useNavigate } from "react-router-dom";
import { AUTH_API_BASE } from "./api/authClient.js";

export default function RequireAuth({ role = "student", children }) {
  const [allowed, setAllowed] = React.useState(null);
  const navigate = useNavigate();
  const redirectedRef = React.useRef(false);

  React.useEffect(() => {
    const ctrl = new AbortController();
    const loginPath = role === "tutor" ? "/auth/tutor/login" : "/auth/login";
    const mePath = role === "tutor" ? "/api/tutor/me" : "/api/student/me";
    const softRedirect = () => {
      if (!redirectedRef.current) {
        redirectedRef.current = true;
        navigate(loginPath, { replace: true });
      }
    };

    (async () => {
      try {
        const res = await fetch(`${AUTH_API_BASE}${mePath}`, {
          method: "GET",
          credentials: "include",
          headers: { Accept: "application/json" },
          cache: "no-store",
          signal: ctrl.signal,
        });

        if (!res.ok) {
          setAllowed(false);
          return softRedirect();
        }

        // нам достаточно факта 200 / ok, содержимое не важно
        setAllowed(true);
      } catch {
        setAllowed(false);
        softRedirect();
      }
    })();

    return () => ctrl.abort();
  }, [role, navigate]);

  if (allowed === null) return null;
  if (!allowed) return null;
  return children;
}
